import http from "./http";
import config from "./config";

// import { config } from "shelljs";
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
// let resquest = "http://192.168.1.103/api/v1"
let resquest = config.api_base_url;

// get请求
export default {
  //账号登录
  login(params) {
    return http.post(`${resquest}/site/login`, params);
  },
  //手机号登录
  mobileLogin(params) {
    return http.post(`${resquest}/site/mobile-login`, params);
  },
  //发送短信验证码
  sendCode(params) {
    return http.post(`${resquest}/site/sms-code`, params);
  },
  //账号注册
  register(params) {
    return http.post(`${resquest}/site/register`, params);
  },
  //修改密码
  reset(params) {
    return http.post(`${resquest}/site/up-pwd`, params);
  },
  //绑定手机号
  bingphone(params) {
    var url = `${resquest}/site/mobile-bind`;
    if (params.token) {
      url += "?access-token=" + params.token;
    }
    return http.post(url, params);
  },
  //登出
  logout(params) {
    return http.post(`${resquest}/site/logout`, params);
  },
  //首页banner列表
  bannerList(params) {
    return http.post(`${resquest}/common/banner/list`, params);
  },
  //活动列表
  activityList(params) {
    var url = `${resquest}/activity/activity/index`;
    if (params.page) {
      url += "?page=" + params.page;
    }
    if (params.page_size) {
      url += "&per-page=" + params.page_size;
    }

    return http.post(url, params);
  },
  //本馆活动
  activityOwn(params) {
    var url = `${resquest}/activity/activity/own`;
    return http.get(url, params);
  },
  //活动检索条件
  activitySearch(params) {
    return http.post(`${resquest}/activity/activity/search`, params);
  },
  //活动详情
  activityDetail(params) {
    return http.get(`${resquest}/activity/activity/detail`, params);
  },
  //活动作品字段
  activityField(params) {
    return http.get(`${resquest}/activity/activity/field`, params);
  },
  //打卡活动字段
  ClockActivityField(params) {
    return http.post(`${resquest}/activity/activity-clock/get-info`, params);
  },
  //活动机构列表
  activityOgran(params) {
    return http.post(`${resquest}/activity/activity/organ`, params);
  },
  //消息列表
  messageList(params) {
    return http.post(`${resquest}/member/message/index`, params);
  },
  //微信登录
  wechatLogin(params) {
    return http.get(`${resquest}/site/wechat-login`, params);
  },
  //微信绑定
  wechatBind(params) {
    return http.get(`${resquest}/site/wechat-bind`, params);
  },
  //微信是否绑定
  wechatIsBind(params) {
    return http.post(`${resquest}/site/wechat-is-bind`, params);
  },
  //微信解除绑定
  wechatUnBind(params) {
    return http.post(`${resquest}/site/wechat-un-bind`, params);
  },
  //上传图片
  uploadImage(params) {
    return http.post(`${resquest}/file/images`, params);
  },
  // 上传音频
  uploadAudio(params) {
    return http.post(`${resquest}/file/voices`, params);
  },
  // 上传视频
  uploadVideo(params) {
    return http.post(`${resquest}/file/videos`, params);
  },
  // 作品上传
  submitForm(params) {
    return http.post(`${resquest}/activity/works/submit`, params);
  },
  // 作品点赞
  workMark(params) {
    return http.post(`${resquest}/activity/mark/submit`, params);
  },
  // 加载作品评论列表
  loadComments(params) {
    var url = `${resquest}/activity/comment/index`;
    if (params.page) {
      url += "?page=" + params.page;
    }
    return http.post(url, params);
  },
  // 提交评论
  submitComment(params) {
    return http.post(`${resquest}/activity/comment/submit`, params);
  },
  // 作品列表
  worksList(params) {
    var url = `${resquest}/activity/works/index`;
    if (params.page) {
      url += "?page=" + params.page;
    }
    if (params.page_size) {
      url += "&per-page=" + params.page_size;
    }
    return http.post(url, params);
  },
  // 作品详情
  worksDetails(params) {
    return http.get(`${resquest}/activity/works/detail`, params);
  },
  //我的作品列表
  myWorks(params) {
    var url = `${resquest}/member/my-works/index`;
    if (params.page) {
      url += "?page=" + params.page;
    }
    if (params.page_size) {
      url += "&per-page=" + params.page_size;
    }

    return http.post(url, params);
  },
  // 我的作品删除
  workDelete(params) {
    return http.post(`${resquest}/member/my-works/del-work`, params);
  },
  //我的消息列表
  myMessage(params) {
    var url = `${resquest}/member/message/index`;
    if (params.page) {
      url += "?page=" + params.page;
    }
    if (params.page_size) {
      url += "&per-page=" + params.page_size;
    }

    return http.post(url, params);
  },
  // 消息详情
  meaasgeDetails(params) {
    return http.get(`${resquest}/member/message/view`, params);
  },
  // 是否有已读消息
  newMessage(params) {
    return http.post(`${resquest}/member/member/view`, params);
  },
  // 获取机构
  loadFrom(params) {
    return http.post(`${resquest}/activity/activity/organ`, params);
  },
  // 获取活跃举办方
  loadOrganize() {
    return http.post(`${resquest}/activity/activity/sponsor`);
  },
  // 修改个人资料
  editUserinfo(params) {
    return http.post(`${resquest}/member/member/update`, params);
  },
  // 有知列表页
  getKnowingList(config) {
    return http.axois(`${resquest}/expend/youzhi/index`, {
      method: "post",
      ...config
    });
  },
  // 有知详情页
  getKnowingDetail(config) {
    return http.axois(`${resquest}/expend/youzhi/detail`, {
      method: "post",
      ...config
    });
  },
  // 视频讲堂首页
  getVideoLecture(config) {
    return http.axois(`${resquest}/expend/videoclass/index`, {
      method: "post",
      ...config
    });
  },
  // 视频讲堂详情
  getVideoDetail(config) {
    return http.axois(`${resquest}/expend/videoclass/detail`, {
      method: "post",
      ...config
    });
  },
  // 视频推荐
  getRecommendVideo(config) {
    return http.axois(`${resquest}/expend/videoclass/recommend`, {
      method: "post",
      ...config
    });
  },
  // 获取某一个视频的评论列表
  getCommlistbyVideo(config) {
    // console.error(config)

    return http.axois(`${resquest}/expend/expend/comment-list`, {
      method: "post",
      ...config
    });
  },
  // 给某一个视频添加评论
  addCommentbyVideo(config) {
    return http.axois(`${resquest}/expend/expend/comment-submit`, {
      method: "post",
      ...config
    });
  },
  // 视频讲堂点赞
  addKudosbyVideoLecture(config) {
    let obj = {
      params: {},
      data: {}
    };
    let config_obj = Object.assign(obj, config);
    console.log("config-----", config_obj);
    return http.axois(`${resquest}/expend/videoclass/mark`, {
      method: "post",
      ...config_obj
    });
  },
  // 获取深度阅读
  getDeepRead(config) {
    return http.axois(`${resquest}/expend/deepread/index`, {
      method: "post",
      ...config
    });
  },
  // 获取深度阅读评论
  getDeepReadComment(config) {
    // let {params ,data } = config;
    // config.data.type = 2;

    config.data.type = 2;
    return http.axois(`${resquest}/expend/expend/comment-list`, {
      method: "post",
      ...config
    });
  },
  // 深度阅读添加评论
  addCommentbyDeepread(config) {
    config.data.type = 2;
    return http.axois(`${resquest}/expend/expend/comment-submit`, {
      method: "post",
      ...config
    });
  },
  // 深度阅读收藏
  collectDeepred(config) {
    return http.axois(`${resquest}/expend/deepread/collect`, {
      method: "post",
      ...config
    });
  },
  // 获取深度阅读列表
  getDeepReadList(config) {
    return http.axois(`${resquest}/expend/deepread/deepread-list`, {
      method: "post",
      ...config
    });
  },
  // 获取拓展数据库 - 菜单
  getExpendMenu(config) {
    return http.axois(`${resquest}/expend/expend/index`, {
      method: "post",
      ...config
    });
  },
  // 收藏列表
  getCollectList(config) {
    return http.axois(`${resquest}/expend/deepread/collect-list`, {
      method: "post",
      ...config
    });
  },
  // 取消收藏
  cancelCollect(config) {
    return http.axois(`${resquest}/expend/deepread/cancel-collect`, {
      method: "post",
      ...config
    });
  },
  // 获取青青听列表
  getqqListenList(config) {
    return http.axois(`${resquest}/expend/qqlisten/index`, {
      method: "post",
      ...config
    });
  },
  // 青青听添加浏览数
  addqqListenView(config) {
    return http.axois(`${resquest}/expend/qqlisten/view`, {
      method: "post",
      ...config
    });
  },
  // 有知点赞
  addislick(config) {
    return http.axois(`${resquest}/expend/youzhi/mark`, {
      method: "post",
      ...config
    });
  },
  // 青青写列表
  getqqWriteList(config) {
    return http.axois(`${resquest}/expend/qqwrite/index`, {
      method: "post",
      ...config
    });
  },

  // 青青写详情
  getqqWriteDetail(config) {
    return http.axois(`${resquest}/expend/qqwrite/detail`, {
      method: "post",
      ...config
    });
  },
  // 获取青青写评论
  getqqWriteComment(config) {
    // let {params ,data } = config;
    // config.data.type = 2;

    config.data.type = 3;
    return http.axois(`${resquest}/expend/expend/comment-list`, {
      method: "post",
      ...config
    });
  },
  // 青青写添加评论
  addCommentbyqqWrite(config) {
    config.data.type = 3;
    return http.axois(`${resquest}/expend/expend/comment-submit`, {
      method: "post",
      ...config
    });
  },
  // 青青写作品上传
  uploadWorks(config) {
    // config.data.type = 3;
    return http.axois(`${resquest}/member/my-write/submit`, {
      method: "post",
      ...config
    });
  },
  // 我的青青写作品
  getmyqqWriteWorks(config) {
    return http.axois(`${resquest}/member/my-write/index`, {
      method: "post",
      ...config
    });
  },
  // 青青写作品删除
  deleteqqWriteworks(config) {
    return http.axois(`${resquest}/member/my-write/del-qqwrite`, {
      method: "post",
      ...config
    });
  },
  // 青青写作品编辑
  editqqWriteworks(config) {
    return http.axois(`${resquest}/member/my-write/save`, {
      method: "post",
      ...config
    });
  },
  // 青青写标签接口
  getqqWritelabel(config) {
    return http.axois(`${resquest}/expend/qqwrite-cate/index`, {
      method: "post",
      ...config
    });
  },
  // 青青写点赞
  addKudosbyqqWrite(config) {
    return http.axois(`${resquest}/expend/qqwrite/mark`, {
      method: "post",
      ...config
    });
  },
  // pc端首页接口
  getHome(config) {
    return http.axois(`${resquest}/expend/expend/pc-index`, {
      method: "post",
      ...config
    });
  },
  // 获取机构id
  getAgencyId(config) {
    return http.axois(`${resquest}/expend/expend/get-ogran`, {
      method: "post",
      ...config
    });
  },
  //  获奖作品筛选
  getScreening(config) {
    return http.axois(`${resquest}/activity/awards-works/provinces`, {
      method: "post",
      ...config
    });
  },
  // 获取获奖作品列表
  getAwardWorks(config) {
    return http.axois(`${resquest}/activity/awards-works/index`, {
      method: "post",
      ...config
    });
  },
  // 验证
  validateInstitution(config) {
    return http.axois(`${resquest}/expend/expend/register`, {
      method: "post",
      ...config
    });
  },
  //  打卡活动页顶部详情
  getClockActivityBanner(config) {
    return http.axois(`${resquest}/activity/activity-clock/detail`, {
      method: "post",
      ...config
    });
  },
  //  打卡排行榜
  getClockRank(config) {
    return http.axois(`${resquest}/activity/activity-clock/rank`, {
      method: "post",
      ...config
    });
  },
  //  阅读打卡书籍列表
  getClockReadBookList(config) {
    return http.axois(`${resquest}/activity/activity-clock/book-list`, {
      method: "post",
      ...config
    });
  },
  //  打卡活动 我的阅读
  getClockByMy(config) {
    return http.axois(`${resquest}/activity/activity-clock/my-read`, {
      method: "post",
      ...config
    });
  },
  //  是否参加打卡活动了
  isaddClock(config) {
    return http.axois(`${resquest}/activity/activity-clock/isinfo`, {
      method: "post",
      ...config
    });
  },
  //  打卡活动提交信息
  submitClockActivityInfo(config) {
    return http.axois(`${resquest}/activity/activity-clock/info`, {
      method: "post",
      ...config
    });
  },
  // 获取活跃举办机构
  // /activity/activity/join-ogran
  getJoinOgran(config) {
    // return http.axois(`${resquest}/activity/activity/join-ogran`,{
    //   method:'post',

    // })
    return http.post(`${resquest}/activity/activity/join-ogran`);
  },
  // 作品页面图书馆列表

  getActivityLibrary(config) {
    return http.axois(`${resquest}/activity/activity/library`, {
      method: "post",
      data: config.data,
      params: config.params
    });
  },
  // 专家筛选条件
  fetchExpertCondition(config) {
    return http.axois(`${resquest}/activity/expert/search`, {
      method: "post",
      data: config.data,
      params: config.params
    });
  },
  // 专家列表
  fetchExpertList(config) {
    return http.axois(`${resquest}/activity/expert/index`, {
      method: "post",
      data: config.data,
      params: config.params
    });
  },
  // 专家详情
  fetchExpertDetail(config) {
    return http.axois(`${resquest}/activity/expert/detail`, {
      method: "post",
      data: config.data,
      params: config.params
    });
  },
  // 专家申请
  fetchExpertApply(config) {
    return http.axois(`${resquest}/activity/expert/submit`, {
      method: "post",
      data: config.data,
      params: config.params
    });
  },
  //
  fetchProvinceList(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/match/library/province`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 专家获取详情
  fetchExpertInfo(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/activity/expert/get-info`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 编辑专家
  fetchEditExpert(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/activity/expert/edit-info`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 提交收货地址 /activity/expert/edit-gift
  fetchGiftAddress(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/activity/expert/edit-gift`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 专家库智库消息列表接口
  fetchExpertNewsList(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/match/expert-dynamics/index`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 专家库智库消息详情接口
  fetchExpertNewsDetail(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/match/expert-dynamics/detail`, {
      method: "post",
      data: data,
      params: params
    });
  },
  // 投票注册
  fetchVoteSign(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/activity/vote/sign`, {
      method: "post",
      data: data,
      params: params
    });
  },
  //
  fetchRichText(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/common/single-page/index`, {
      method: "post",
      data: data,
      params: params
    });
  },

  fetchUploadVideo(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/file/videos`, {
      method: "post",
      data: data,
      params: params,
      ...config
    });
  },
  /**
   * 获取我的作品列表 通过状态
   */
  fetchMyWorksByStatus(config) {
    config = config ? config : {};
    let { data = {}, params = {} } = config;
    return http.axois(`${resquest}/member/my-works/index`, {
      method: "post",
      data,
      params,
      ...config
    });
  },

  fetchArrayBuffer(config) {
    return http.axois(config.url, {
      ...config
    });
  },

  /**
   * 书籍分类
   * @param {*} config
   * @returns
   */
  fetchBookTypes(config) {
    return http.axois(`${resquest}/activity/activity-clock-book/cates`, {
      method: "post",
      ...config
    });
  },

  fetchBooks(config) {
    return http.axois(`${resquest}/activity/activity-clock-book/index`, {
      method: "post",
      ...config
    });
  }
};



// WEBPACK FOOTER //
// ./src/request/api.js